module.exports = __webpack_public_path__ + "img/img-loading.0d305a38.svg";